import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";

const useCanSeeReadingSkills = () => {
  const { data: user } = useUser();
  const {
    activeELALicense,
    activeEssentialsLicense,
    activeScienceLicense,
    activeSSLicense,
    isAuthorizedDistrictAdmin,
    isAuthorizedTeacher,
    isFreeUser,
    isStudent,
    hasAccessToLite,
  } = getUserProperties(user);

  if (hasAccessToLite) return !isStudent;

  const isAuthorizedUser =
    isAuthorizedTeacher && !isFreeUser && !isAuthorizedDistrictAdmin;
  const hasScienceOnly =
    activeScienceLicense && !activeELALicense && !activeSSLicense;
  const hasSocialStudiesOnly =
    activeSSLicense && !activeELALicense && !activeScienceLicense;
  const hasScienceAndSocialStudiesOnly =
    activeScienceLicense && activeSSLicense && !activeELALicense;
  const hasEssentialsOnly =
    activeEssentialsLicense &&
    !activeELALicense &&
    !activeScienceLicense &&
    !activeSSLicense;

  const hasAuthorizedLicense =
    hasScienceOnly ||
    hasSocialStudiesOnly ||
    hasScienceAndSocialStudiesOnly ||
    hasEssentialsOnly;
  const showReadingSkill = isAuthorizedUser && hasAuthorizedLicense;

  return showReadingSkill;
};

export default useCanSeeReadingSkills;
